var _style, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.3 18.9",
    style: {
      enableBackground: "new 0 0 20.3 18.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -1,
    className: "st0",
    width: 20,
    height: 20
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0-1h21.4v21.4H0V-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10,0.6c-4.9,0-8.9,4-8.9,8.9s4,8.9,8.9,8.9s8.9-4,8.9-8.9S15,0.6,10,0.6z M10.9,15.7H9.1V14h1.8V15.7z  M12.8,8.8L12,9.7c-0.6,0.6-1,1.2-1,2.5H9.1v-0.4c0-1,0.4-1.9,1-2.5l1.1-1.1c0.3-0.3,0.5-0.8,0.5-1.3C11.8,5.8,11,5,10,5 S8.3,5.8,8.3,6.8H6.5c0-2,1.6-3.6,3.6-3.6s3.6,1.6,3.6,3.6C13.6,7.6,13.3,8.3,12.8,8.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.9e469e369f4f8dae66c97e3c7ade9ad0.svg";
export { ForwardRef as ReactComponent };